import styled from 'styled-components';

export const SearchMarkingCriteria = styled.input`
  font-family: IBM Plex Sans;
  padding: 7px 20px;
  padding-right: 30px;
  border-radius: 15px;
  border: 1px solid #7b7382;
  outline: none;
  width: 100%;
  min-width: 200px;
  position: relative;
  z-index: 1;
`;
